import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AnalyticsModalPayload {
  tipoElemento: string;
  tipoEvento?: 'Interacción' | 'Visualización';
  tipoZona?: string;
  zona: string;
  subZona?: string;
  seccion?: string;
  subSeccion?: string;
  cta: string;
  pageTitle?: string;
}

export interface InfoModalData {
  title?: string;
  message: string;
  buttonText?: string;
  cancelText?: string;
  /**
   * Ruta del ícono mostrado en el header del modal.
   * Si no se especifica usa `assets/icons/ico_alert_new.svg` (alerta).
   * Ejemplo de uso: `assets/icons/ico_bell_check.svg` para escenarios de éxito.
   */
  iconSrc?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  closable?: boolean;
  analyticsOnShow?: AnalyticsModalPayload;
  analyticsOnConfirm?: AnalyticsModalPayload;
}

/**
 * Modal de segunda confirmación cuando el usuario marca una respuesta de
 * control distinta a la esperada (PEP / residencia / cuenta, según flujo).
 * La lógica de apertura sigue en cada pantalla; aquí solo el copy unificado.
 */
export const DECLARACION_CONTROL_DOUBLE_CHECK_MODAL_COPY = {
  title: '¿Estás seguro de tus respuestas?',
  message:
    'Recuerda que estas preguntas son importantes para tu participación.',
  buttonText: 'Confirmar',
  cancelText: 'Cancelar',
} as const satisfies Pick<
  InfoModalData,
  'title' | 'message' | 'buttonText' | 'cancelText'
>;

@Injectable({
  providedIn: 'root'
})
export class InfoModalService {
  private isModalVisibleSubject = new BehaviorSubject<boolean>(false);
  isModalVisible$ = this.isModalVisibleSubject.asObservable();
  
  private modalDataSubject = new BehaviorSubject<InfoModalData | null>(null);
  modalData$ = this.modalDataSubject.asObservable();

  constructor() { }

  show(data: InfoModalData) {
    this.isModalVisibleSubject.next(true);
    this.modalDataSubject.next(data);
  }

  hide() {
    this.isModalVisibleSubject.next(false);
    this.modalDataSubject.next(null);
  }
}
